
export default {
  firstTimeLoad: false,
  activityForTabs: {},
  activityHistoryForTab: [],
  mainListSavedFilter: {},
  mainListQuickFilters: [],
  quickFiltersDatesFrom: [],
  quickFiltersDatesTo: [],
  sortField: '',
  sortFieldId: 0,
  sortOrder: 0,
  page: 1,
  rows: 25,
  hardLoad: 0,
  softReload: 0
}